import React from "react";
import "./Loading.css";

const Loading = () => {
  return <div className="spinner"></div>;
};

export default Loading;
